import React, {useState, useEffect, useContext} from 'react'
import { DataGrid,  GridToolbar} from '@mui/x-data-grid'
import { Button} from '@mui/material';
import ScheduleInterview from './ScheduleInterview';
import ScheduleInterviewUI from './ScheduleInterviewUI';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import EventIcon from '@mui/icons-material/Event';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CheckIcon from '@mui/icons-material/Check';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';
import TextField from "@mui/material/TextField";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { UserContext } from './UserContext';
import TimePicker from '@mui/lab/TimePicker';
import { useSearchParams } from 'react-router-dom';
import BulkDataUpload from './BulkDataUpload';
import Checkbox from '@mui/material/Checkbox';
import Timer from './Timer';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ApplicantPopup from './ApplicantPopup';

// import { Splitscreen } from '@mui/icons-material';
// import { id } from 'date-fns/locale';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';

const WebsiteEnquiries = (props) => {
  
const [searchParams] = useSearchParams();
const [messages, setMessages] = useState([]);
const [OpenShedule, setOpenScedule ]= React.useState();
const [name, setName] = useState();
const [mail, setMail] = useState();
const [mobile, setMobile] = useState();
const [jobId, setJobId] = React.useState();
const [jobTitle, setJobTitle] = React.useState();
const [applicantId,setApplicantId]= useState()
const [companyName, setCompanyName] = useState();
const [open, setOpen] = React.useState(false);
const [Rounds, setRounds] = useState();
const [InterViewerName, setInterViewerName]= useState("");
const [InterViewDate, setInterViewDate] = React.useState(new Date());
const [InterViewTime, setInterViewTime] = React.useState();
const [interviewlocation, setInterviewlocation] = useState();
const [selectedRow,setSelectedRow] = useState();
const [openApplicant,setOpenApplicant] = useState(false)
const [isLoading, setIsLoading] = useState(false);
const { user, setUser} = useContext(UserContext);


//UseEffect
useEffect (()=>{
 
   
  getWebsiteEnquiries()

  
},[])

const getWebsiteEnquiries = ()=>{
  
    let apiURL="";
  
    apiURL=process.env.REACT_APP_API_URL + "/website/getwebsitemessages";
    let apiParams = {
        method:"GET", 
        headers:{
          authtoken: localStorage.getItem("loggedintoken")
        },
    };
    
    fetch(apiURL, apiParams)
    .then((res)=> (res.status===200 ? res.json() : res.text()))
    .then((repos)=> {
        if (repos.data) {
          console.log(repos.data)
          setMessages(repos.data)
          
        }else props.showAlert(""+(repos.message || repos),"error");  
    }) 
    .catch((err) => props.showAlert((''+err),"error"));
  }




  const rowData = (messages||[])?.map((msg) => {
  

    return{
  id: msg?._id,  
  MessagedOn: (new Date(msg?.createdAt).toISOString()).slice(0,10) +" "+ (new Date(msg?.createdAt).toISOString()).slice(11,16),
  name: msg?.name,
  mobile: msg?.mobile,
  email: msg?.email,
  ip: msg?.ip,
  messages: msg?.message,
  dublicateCount : msg?.duplicateCount,
  device: msg?.device,
 
   };
  });
  

const [filterModel, setFilterModel] = React.useState({
  items: user.accesstype == 5 ? [
    // {columnField: 'rounds', operatorValue: 'contains', value:"Verification"}
  ]: [
    // {columnField: 'hrname', operatorValue: 'contains', value:user.name}
  ],
});



const cols = [

  {field:'id', headerName: '',width: 190,hide: true },
  {field:'MessagedOn', headerName: 'Enquiry Date',width: 190 },
  {field:'name', headerName: 'Name',width: 190 },
  {field:'mobile', headerName: 'Mobile',width: 190 },
  {field:'email', headerName: 'Email',width: 180, headerAlign:'center', align:"center"},
  {field:'ip', headerName: 'IP',width: 180, headerAlign:'center', align:"center"},
  {field:'device', headerName: 'Device',width: 800, headerAlign:'center', align:"center"},
  {field:'messages', headerName: 'Messages',width: 800, headerAlign:'center',},
 
  ];

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  
  


const ResendWhatsapp = (row)=>{

let apiURL="https://"+(user.device === "mobile"?"api":"web")+".whatsapp.com/send/?phone=+91"+row.mobile.trim().replace(' ','').substring(row.mobile.trim().replace(' ','').length-10)+"&type=phone_number&app_absent=0&text=Good Day "+row.name+",%0a%0aI am contacting you for a job vacancy. Please let me know the best time to call you.%0a%0aMy name is "+user.name+", I am from Bizi Bees Outsourcing Private Limited. You can call me on "+user.phone+" as well at your convenient time to discuss about the vacancy.%0a%0aPlease follow us on our LinkedIn page url below for latest updates.%0a%0ahttps://www.linkedin.com/company/bizi-bees-outsourcing";
const newWindow = window.open(apiURL, '_blank')
}
  
const editApplicants = (row) => {
// console.log(row)
  setApplicantId(row.applicantId|| "");
  setOpenApplicant(true);
}


  
  const scheduleinterview = (row) =>{

    setSelectedRow(row)
    
        setOpenScedule(true);
    
      }
    
 

  const showApplicant = (row) =>{
    window.isIntentionalRedirect = true;
    window.location.href="/applicants?applicantid="+row.applicantid;
  }



  return (
    <div style={{position:"absolute",width:"100%",height:"calc(100% - 10px)"}}>
    <div style={{height:"100%",width: '100%'}}>
      <DataGrid rows={rowData}
                        columns={cols}  
                        // checkboxSelection
               components={{
                  Toolbar: GridToolbar,
                  }}
              filterModel={filterModel}
              onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
            //    onRowDoubleClick={(e)=>editApplicants(e.row)}
           />

 </div>

 {/* <ApplicantPopup openApp={openApplicant} showAlert={props.showAlert} id={applicantId} closeApp={()=>{setOpenApplicant(false);}} />  */}
 
</div>
  ) 
}

export default WebsiteEnquiries







